<div class="modal-content">
    <div class="header">
        <h3>Delete Rate Limit Profile</h3>
        <img src="assets/icons/close-sm.svg" alt="" (click)="modal.deny(undefined)">
    </div>
    <div class="content">
        <p>Are you sure you want to delete this Global Rate Limit Profile?</p>
    </div>
    <div class="ctrl-btns">
        <button class="cancel" (click)="modal.deny(undefined)">Cancel</button>
        <button class="delete" (click)="modal.approve(undefined)">Yes</button>
    </div>
</div>